import { ANALYTICS_KEY } from '../constants.js';
import '../ui/Div/index.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Div } from '../ui/Div/Div.js';
function TwoColumnContainer({
  leftCol,
  rightCol,
  rightPercentage = 50,
  leftPercentage = 50,
  reverseOnWrap,
  wrapOnTablet,
  gap = 0
}) {
  const wrap = reverseOnWrap ? 'wrap-reverse' : 'wrap';
  const sumWrapProp = leftPercentage + rightPercentage > 100 ? wrap : 'nowrap';
  return /*#__PURE__*/jsxs(Div, {
    flexWrap: {
      sm: wrap,
      md: wrapOnTablet ? wrap : sumWrapProp,
      lg: sumWrapProp
    },
    justifyContent: "space-evenly",
    width: "100%",
    height: "fit-content",
    gap: gap,
    children: [/*#__PURE__*/jsx(Div, {
      flexShrink: 1,
      flexGrow: 1,
      flexBasis: {
        sm: '100%',
        md: wrapOnTablet ? '100%' : `${leftPercentage}%`,
        lg: `${leftPercentage}%`
      },
      maxWidth: "100%",
      "data-qa": ANALYTICS_KEY.TwoColumnContainerLeft,
      children: leftCol
    }), /*#__PURE__*/jsx(Div, {
      flexShrink: 1,
      flexGrow: 1,
      flexBasis: {
        sm: '100%',
        md: wrapOnTablet ? '100%' : `${rightPercentage}%`,
        lg: `${rightPercentage}%`
      },
      maxWidth: "100%",
      "data-qa": ANALYTICS_KEY.TwoColumnContainerRight,
      children: rightCol
    })]
  });
}
export { TwoColumnContainer };
//# sourceMappingURL=TwoColumnContainer.js.map
